import React, { useEffect, useContext, Fragment, useState } from 'react';
import Traductor from './Traductor';
import { UserContext } from '../contexts/UserContext';
import { withRouter } from 'react-router-dom';
import UserModule from '../modules/UserModule';
import PasswordModule from '../modules/PasswordModule';
import ScrollToTop from '../components/ScrollToTop';
import { withCookies } from 'react-cookie';
import { Compare } from './../Functions';
import PreferenceModule from './PreferenceModule';
import UserService from '../services/UserService';
import ParseService from '../services/ParseService';
import Globals from '../Globals';

import usePermissions from 'hooks/usePermissions';
import { READONLY_PERMISSION } from 'constants/Permissions';
import ToastNotification from './bronson/ToastNotification';
//CSS
import './css/profile.css';
import '../css/components/bronson/myProfileUser.css';

function Profile({ match, cookies, history }) {
    const t = new Traductor();
    const { checkPermission } = usePermissions();
    const { user, preferences, setPreferences } = useContext(UserContext);
    const [showToast, setShowToast] = useState(null);

    useEffect(() => {
        setTimeout(() => {
            window.bronson.ComponentRegister.initAll();
            const { value } = match.params;
            if (
                (value == 'account' || value == undefined) &&
                document.getElementById('btn_go_to_account')
            )
                document.getElementById('btn_go_to_account').click();
            if (
                value === 'password' &&
                document.getElementById('btn_go_to_password')
            )
                document.getElementById('btn_go_to_password').click();
            if (
                checkPermission('CNST_GESTION_COMERCIAL_CONCESIONARIO') &&
                value === 'preferences' &&
                document.getElementById('btn_go_to_preferences')
            )
                document.getElementById('btn_go_to_preferences').click();
        }, 200);
        //window.bronson.$$('#auctions-tabs').component('tabs');
    }, [match, preferences]);

    const savePreferences = async data => {
        if (preferences.PreferenceId == 0 || !Compare(preferences, data)) {
            await new UserService()
                .savePreferences(
                    cookies.get(Globals.COOKIES.JWT).AccessToken,
                    data
                )
                .then(response => {
                    if (response && response.Result) {
                        let preferenceResponse = new ParseService().Parse(
                            response.Result
                        );
                        if (preferenceResponse) {
                            data.PreferenceId = preferenceResponse.PreferenceId;
                            data.TransportId = preferenceResponse.TransportId;
                            setPreferences(data);
                        }
                        setShowToast({ title: '¡Guardado!', text: 'Preferencia guardada correctamente', type: 'success', closeText: 'Cerrar', timeout: false });
                    } else {
                        setShowToast({ title: '¡Error!', text: 'No se ha podido guardar la preferencia', type: 'error', closeText: 'Cerrar', timeout: false });
                    }
                });
        }
    };

    const getNameUser = (character = false) => {
        let name = null;
        let surname = null;
        let surname2 = null;
        let result = '';

        if (character) {
            name = user.data.Name !== undefined ? user.data.Name.charAt(0) : '';
            surname =
                user.data.Surname !== undefined
                    ? user.data.Surname.charAt(0)
                    : '';
            result = name + surname;
        } else {
            name = user.data.Name !== undefined ? user.data.Name : '';
            surname = user.data.Surname !== undefined ? user.data.Surname : '';
            surname2 =
                user.data.Surname2 !== undefined ? user.data.Surname2 : '';
            result = name + ' ' + surname + ' ' + surname2;
        }
        return result;
    };

    const printProfile = () => {
        if (!user.logged) return null;
        return (
            <Fragment>
                <div className="c-my-profile-user c-my-profile-user--large u-mt u-mb-xlarge">
                    <div className="c-my-profile-user__initials">
                        <span className="c-page-head-nav__user-text">
                            {getNameUser(true)}
                        </span>
                    </div>
                    <h5 className="c-my-profile-user__name u-mt">
                        {user.data.Name +
                            ' ' +
                            user.data.Surname +
                            ' ' +
                            user.data.Surname2}
                    </h5>
                    <p className="c-my-profile-user__info"></p>
                </div>
                <div className="c-tabs js-tabs c-tabs-container">
                    <nav>
                        <ul className="c-tabs__nav  js-tabs__nav ">
                            <li className="c-tabs__nav-item">
                                <button
                                    id="btn_go_to_account"
                                    className="c-tabs__nav-link  js-tabs__nav-link  "
                                >
                                    <span className="c-tabs__text">
                                        {t.getTraduction('Profile')}
                                    </span>
                                </button>
                            </li>
                            <li className="c-tabs__nav-item">
                                <button
                                    id="btn_go_to_password"
                                    className="c-tabs__nav-link  js-tabs__nav-link  "
                                >
                                    <span className="c-tabs__text">
                                        {t.getTraduction('Password')}
                                    </span>
                                </button>
                            </li>
                            {!checkPermission(READONLY_PERMISSION) &&
                            checkPermission(
                                'CNST_GESTION_COMERCIAL_CONCESIONARIO'
                            ) ? (
                                <li className="c-tabs__nav-item">
                                    <button
                                        id="btn_go_to_preferences"
                                        className="c-tabs__nav-link  js-tabs__nav-link"
                                    >
                                        <span className="c-tabs__text">
                                            {t.getTraduction('Preferences')}
                                        </span>
                                    </button>
                                </li>
                            ) : null}
                        </ul>
                    </nav>
                    <div>
                        <UserModule />
                        <PasswordModule
                            IsResetPasswordEmail={false}
                            history={history}
                        ></PasswordModule>
                        {checkPermission(
                            'CNST_GESTION_COMERCIAL_CONCESIONARIO'
                        ) ? (
                            <div className="c-tabs__content  js-tabs__content u-mb-xlarge">
                                <PreferenceModule
                                    data={preferences}
                                    options={{
                                        button: {
                                            text: t.getTraduction(
                                                'BtnGuardarPreferencias'
                                            ),
                                            disabled: false,
                                            function: savePreferences,
                                        },
                                        transport: {
                                            userHasTransportAvailable:
                                                user.cifs &&
                                                user.cifs[0] &&
                                                !user.cifs[0].IsParticipada &&
                                                user.cifs[0].CIF.toUpperCase() !=
                                                    'A15011745',
                                        },
                                    }}
                                ></PreferenceModule>
                            </div>
                        ) : null}
                    </div>
                </div>
            </Fragment>
        );
    };

    return (
        <section className="c-my-profile">
            <ScrollToTop></ScrollToTop>
            <div className="o-component-wrapper">
                <div className="o-page-wrap o-page-wrap--xsmall">
                    {printProfile()}
                </div>
            </div>
            {showToast && <ToastNotification options={showToast} closeToast={() => setShowToast(null)} />}
        </section>
    );
}
export default withCookies(withRouter(Profile));
